<template>
    <header>
        <div class="container">
            <div class="header-logo"><img src="@/assets/images/telltomm.svg" alt="TellTOMM Logo" /></div>
            <div class="header-info" :style="{justifyContent: question && question.preset.name.slice(0,3) !== 'ASQ' ? 'center' : 'space-between'}">
                <div class="info-left" v-if="question && question.preset.name.slice(0,3) == 'ASQ'">
                    <div class="date-wrapper">
                        <div class="date-text">
                            <p style="margin-right: 20px;"><span class="label">Date entered:</span></p>
                        </div>
                        <span>{{ formatDate( new Date()) }}</span>
                    </div>
                    <div v-if="question && question.preset.name.slice(0,3) == 'ASQ' && question.preset.name !== 'ASQ-SE'" div class="date-wrapper">
                        <div class="date-text">
                            <p style="margin-right: 20px;"><span class="label">Date completed:</span></p>
                        </div>
                        <CustomCalender :dateAdded="dateAdded" @input="updateDate"></CustomCalender>
                        <!-- <dropdown
                            label="Select report"
                            :options="reportOptions"
                            :colour="'#e4f4f9'"
                            v-model="report"
                        /> -->
                    </div>
                    <!-- <div class="dates">   
                        <div><span>Date entered: </span><span>00/00/00</span></div>
                        <div><span>Date ASQ-3 completed: </span><span>00/00/00</span></div>
                    </div> -->
                </div>
                <div class="preset-name"><p v-if="question" :style="{marginLeft: question.preset.name.slice(0,3) !== 'ASQ' ? '-10%' : ''}">{{ question.preset.name }}</p></div>
                <div class="info-right" v-if="question && question.preset.name.slice(0,3) == 'ASQ'">
                    <div class="wrapper">
                        <div class="name"><p><span class="label">Baby name</span></p></div>
                        <div class="dob">
                            <p style="margin-right: 20px;"><span class="label">EDD:</span> <span>{{edd}}</span></p>
                            <p><span class="label">DOB: </span><span>{{dob}}</span></p>
                        </div>
                        <div class="age">
                            <p style="margin-right: 30px;"><span class="label">Developmental age:</span> <span>##</span></p>
                            <p><span class="label">Age: </span><span>##</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="question-title" v-if="question && question.title" :style="{marginTop: question.preset.name.slice(0,3) !== 'ASQ' ? '20px' : ''}">
            <strong v-html="bb(question.title)"></strong>
        </p>
        <p
            class="question-subtitle"
            v-if="question && question.subtitle"
            v-html="bb(question.subtitle)"
        ></p>
    </header>
</template>
  
<script>
import bbCodeParser from 'js-bbcode-parser';
// import Dropdown from '@/components/Dropdown';
import CustomCalender from '@/components/CustomCalender';
export default {
  name: 'Header',
  components: { 
    // Dropdown,
     CustomCalender 
  },
  props: {
    question: {
      type: [Object, undefined],
      required: false,
    },
  },
  
  data() {
    return {
      reportOptions:[{"key":"11","label":"option 1"},{"key":"22","label":"option 2"}],
      report:null,
      dateAdded: undefined,
      edd: '00/00/00',
      dob: '00/00/00'
    };
  },
  methods: {
    bb(str) {
      return bbCodeParser.parse(str);
    },
    // formatDate(input) {
    //   let pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
    //   if (!input || !input.match(pattern)) {
    //     return '00/00/00';
    //   }
    //   return input.replace(pattern, '$2/$3/$1');
    // },
    async updateDate(date) {
      let dd = String(date.getDate()).padStart(2, '0');
      let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = date.getFullYear();
      let newDate = dd + '/' + mm + '/' + yyyy;
      let response = await this.$http.post('/survey/updateDateAdded', {
        dateAdded: newDate.split("/").reverse().join("-")
      });
      this.dateAdded = response.data.date_added;
    },
    async getDate() {
      let response = await this.$http.get('/survey/getDateAdded', {
      });
      this.dateAdded = response.data.date_added;
    },
    async getEddAndDob() {
      let response = await this.$http.post('/survey/getEDDAndDob', {});
      if(response.data.dob) {
        this.dob = this.formatDate(response.data.dob);
      }
      if(response.data.edd) {
        this.edd = this.formatDate(response.data.edd);
      }
    },
    formatDate(date) {
      if(date && date.getDate) {
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = date.getFullYear().toString().slice(-2);
        let newDate = dd + '/' + mm + '/' + yyyy;
        return newDate;
      } else if (date) {
        let splitDate = date.split('-');
        if(splitDate.count == 0){
            return null;
        }
        let year = splitDate[0];
        let month = splitDate[1];
        let day = splitDate[2]; 

        return month + '/' + day + '/' + year;
      }

    },
  },
  mounted() {
    this.getDate();
    this.getEddAndDob();
  }
}
</script>
  
<style lang="scss" scoped>
header{
    text-align: center;
    span{
        color: #1381A2;
    }
    p{
        margin: 0;
    }
    .container{
        display: flex;
        border-bottom: 1px solid #03aaa8;
        padding-bottom: 20px;
        .header-logo{
            flex-basis: 10%;
            img{
                width: 60px;
            }
        }
        .header-info{
            flex-basis: 90%;
            display: flex;
            //justify-content: center;
            //justify-content: space-between;
            .info-left{
                display: flex;
                flex-direction: column;
                justify-content: end;
                max-width:235px;
                .date-wrapper{
                    margin-top: 10px;
                    display: flex;
                    .date-text{
                        align-self: center;
                    p{
                        text-align: left;
                        font-weight: 600;
                    }
                }
                    // .tt-dropdown {
                    //     background-color: #e4f4f9!important;
                    // }
                }
                .dates{
                    div{
                        text-align: left;
                        font-weight: 600;
                    }
                }
            }
            .preset-name{
                min-height: 110px;
                display: flex;
                p {
                    //margin: 0px 6.5%;
                    color: #03aaa8;
                    font-weight: 600;
                    font-size: 32px;
                    align-self: flex-end;
                }
           }
           .info-right{
            min-width: 325px;
            p{
                text-align: left;
            }
            .wrapper{
                p{
                    .label{
                        font-weight: 600;
                    }    
                }
                background-color: #E4F4F9;
                display: flex;
                flex-direction: column;
                padding: 25px 12px;
                border-radius: 42px 42px 42px 0px;
                .dob{
                    display: flex;
                }
                .age{
                    display: flex;
                }
            }
           }
        }
    }
    .question-title,
        .question .subtitle {
        font-size: 24px;
        line-height: 1.4em;
    }
}
</style>
  